export default function updateCourseCatalog() {
    // a.k.a. "All Courses" page

    // add page header
    let pageHeader = document.createElement('h1');
    pageHeader.innerText = 'Explore ClickUp University';
    
    // move search bar container div into header section of page
    let searchBar = document.querySelector('#catalogSearchInput');
    searchBar.placeholder = 'Search for courses';

    let mainContainer = document.querySelector('#main-container');
    let searchContainer = document.querySelector('.search-filter-page .search-container');

    searchContainer.prepend(pageHeader);
    mainContainer.prepend(searchContainer);
};
